// §4.4 partial — wallet routes. Composer auto-collects into routes.generated.ts.
import { lazyWithRetry } from "@/lib/lazy/lazyWithRetry";
import type { RouteObject } from "react-router-dom";
import { RequireAuth } from "@/features/auth";

const WalletPage = lazyWithRetry(() => import("./pages/WalletPage"));
const PurchasesPage = lazyWithRetry(() => import("./pages/PurchasesPage"));
const TopupsPage = lazyWithRetry(() => import("./pages/TopupsPage"));

const routes: RouteObject[] = [
  {
    Component: RequireAuth,
    children: [
      { path: "/wallet", Component: WalletPage },
      { path: "/wallet/history", Component: PurchasesPage },
      { path: "/wallet/topups", Component: TopupsPage },
    ],
  },
];

export default routes;
